<template>
    <div class="option-operate-wrap">
        <Button
            :text="replaceTxt"
            :icon="replaceIcon"
            :hoverIcon="replaceIconHover"
            @btnClick="clickHandler"
            class="replace-btn"
            v-if="isShowReplace"
        />
        <div class="update-tip" v-show="isShowTip">
            <Icon width="12" height="9" bgPosition="-387px -59px"></Icon>
            {{ tipTxt }}
        </div>
    </div>
</template>

<script>
import Button from "@/views/zhiji/bComponents/buttons/Button";
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "OptionOperate",
    components: {
        Button,
        Icon
    },
    data() {
        return {
            isShowTip: false,
            replaceIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -39px -78px",
            replaceIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -39px -95px",
            timer: ""
        };
    },
    computed: {
        isShowReplace() {
            let data = this.getStorePorp("questionInfo");
            if (data.sceneClassId == "def" || data.sceneClassId == "") {
                return false;
            } else {
                return true;
            }
        },
        replaceTxt() {
            return this.$t("zhiji.answer.replaceTip");
        },
        tipTxt() {
            return this.$t("zhiji.answer.updatedTip");
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        clickHandler() {
            let data = this.getStorePorp("questionInfo");
            if (data.sceneClassId && data.sceneClassId != "def") {
                this.zhiji
                    .requestByServiceName("getRecommendShortbar", {
                        sceneId: data.sceneClassId,
                        questionId: data.questionId,
                        lang: this.$store.state.zhiji.questionEdit["currentSynonym"]
                    })
                    .then(result => {
                        this.$store.commit("zhiji/editQsUpdateAnswer", {
                            type: "addOption",
                            recommend: true,
                            options: result
                        });
                        this.isShowTip = true;
                        this.timer && clearTimeout(this.timer);
                        this.timer = setTimeout(() => {
                            this.isShowTip = false;
                        }, 2000);
                    });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.option-operate-wrap {
    margin: 0 20px;
    display: flex;
    align-items: center;
    .replace-btn {
        height: 24px;
        line-height: 1;
        margin-right: 12px;
        padding: 0px 13px;
        border: 1px solid #d8e4f0;
        border-radius: 12px;

        .before-icon {
            width: 14px;
            height: 14px;
        }
    }
    .update-tip {
        color: #00c972;
    }
}
</style>
